module.exports = __webpack_public_path__ + "img/etsy-registry.88bca9e5.png";